import React, { useState } from 'react'
import { useGardenContext } from '../context/GardenContext'

const GardenList: React.FC = () => {
  const { 
    gardens, 
    selectedGardenId, 
    setSelectedGardenId,
    createGarden, 
    deleteGarden, 
    getGardenStats 
  } = useGardenContext()
  
  const [showCreate, setShowCreate] = useState(false)
  const [newGardenName, setNewGardenName] = useState('')

  const handleCreate = () => {
    if (newGardenName.trim()) {
      const id = createGarden(newGardenName.trim(), 20, 20)
      setNewGardenName('')
      setShowCreate(false)
      setSelectedGardenId(id)
    }
  }

  if (gardens.length === 0 && !showCreate) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: '2rem' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🌱</div>
        <h3>No Gardens Yet</h3>
        <p style={{ color: '#666', marginBottom: '1.5rem' }}>
          Create your first garden to start planning
        </p>
        <button 
          className="btn btn-primary"
          onClick={() => setShowCreate(true)}
        >
          Create Garden
        </button>
      </div>
    )
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h3>Your Gardens ({gardens.length})</h3>
        <button 
          className="btn btn-secondary"
          onClick={() => setShowCreate(true)}
        >
          + New Garden
        </button>
      </div>

      {showCreate && (
        <div className="card" style={{ marginBottom: '1rem' }}>
          <h4>Create New Garden</h4>
          <div className="form-group" style={{ marginTop: '1rem' }}>
            <label>Garden Name</label>
            <input
              type="text"
              value={newGardenName}
              onChange={(e) => setNewGardenName(e.target.value)}
              placeholder="My Vegetable Garden"
              onKeyPress={(e) => e.key === 'Enter' && handleCreate()}
            />
          </div>
          <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
            <button 
              className="btn btn-primary"
              onClick={handleCreate}
              disabled={!newGardenName.trim()}
            >
              Create
            </button>
            <button 
              className="btn btn-secondary"
              onClick={() => {
                setShowCreate(false)
                setNewGardenName('')
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {gardens.map(garden => {
          const stats = getGardenStats(garden.id)
          const isSelected = selectedGardenId === garden.id
          
          return (
            <div
              key={garden.id}
              onClick={() => setSelectedGardenId(garden.id)}
              style={{
                padding: '1rem',
                background: isSelected ? '#e8f5e9' : 'white',
                border: `2px solid ${isSelected ? '#4caf50' : '#ddd'}`,
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h4 style={{ margin: 0 }}>{garden.name}</h4>
                  <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem', color: '#666' }}>
                    {stats?.plantedBeds || 0} of {stats?.totalBeds || 0} beds planted
                    {stats && stats.utilization > 0 && (
                      <span style={{ marginLeft: '0.5rem' }}>
                        ({Math.round(stats.utilization)}% full)
                      </span>
                    )}
                  </p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  {isSelected && (
                    <span style={{ fontSize: '0.8rem', color: '#4caf50', fontWeight: 'bold' }}>
                      ✓ Selected
                    </span>
                  )}
                  <button
                    className="btn btn-secondary"
                    style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem' }}
                    onClick={(e) => {
                      e.stopPropagation()
                      if (confirm(`Delete "${garden.name}"? This cannot be undone.`)) {
                        deleteGarden(garden.id)
                      }
                    }}
                  >
                    🗑️
                  </button>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default GardenList
